import { ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";

const cols = [
  {
    title: "Platform",
    links: [
      { label: "The Rules", id: "rules" },
      { label: "How It Works", id: "how-it-works" },
      { label: "Trust & Verification", id: "trust" },
      { label: "FAQ", id: "faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "No-Show Policy", id: "rules" },
      { label: "Licensing Compliance", id: "trust" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "support@guardgig28.com", href: "mailto:support@guardgig28.com" },
      { label: "SIA Public Register", href: "https://services.sia.homeoffice.gov.uk/PublicRegister/SearchPublicRegister" },
    ],
  },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-[#05070b] py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-amber-500 text-[#07090e]">
                <ShieldCheck className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <span className="font-display text-xl font-extrabold uppercase tracking-tight text-slate-50">
                Guard<span className="text-amber-500">Gig</span>28
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-500">
              On-demand security staffing with a spine. SIA-licensed guards, verified
              venues, and one rule that keeps everyone honest: show up or you're out.
            </p>
            <div data-testid="footer-status" className="mt-6 inline-flex items-center gap-2 rounded-full border border-emerald-500/25 bg-emerald-500/5 px-4 py-1.5">
              <span className="animate-pulse-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
              <span className="font-mono-tag text-[9px] text-emerald-400">All systems operational</span>
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <p className="font-mono-tag text-[10px] text-slate-500">{col.title}</p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a
                        data-testid={`footer-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                        href={l.href}
                        target={l.href.startsWith("http") ? "_blank" : undefined}
                        rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                        className="text-sm text-slate-400 transition-colors hover:text-amber-500"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <button
                        data-testid={`footer-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                        onClick={() => (l.to ? navigate(l.to) : scrollToSection(l.id))}
                        className="text-sm text-slate-400 transition-colors hover:text-amber-500"
                      >
                        {l.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono-tag text-[9px] text-slate-600">© 2026 GuardGig28. All rights reserved.</p>
          <p className="font-mono-tag text-[9px] text-slate-600">Rule 01: Show up or you're banned. Applies to everyone.</p>
        </div>
      </div>
    </footer>
  );
}
